import './PrivacyPolicy.css';
import { useTranslation, Trans } from 'react-i18next';

function TermsOfUse() {
  const { t } = useTranslation();

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>{t('terms.title')}</h1>
        <p className="last-updated">{t('terms.lastUpdated')}</p>
        <p className="version">{t('terms.version')}</p>

        <div className="policy-intro">
          <p>{t('terms.intro')}</p>
        </div>

        {/* Section I */}
        <section className="policy-section">
          <h2>{t('terms.s1.title')}</h2>
          <Trans i18nKey="terms.s1.p1" components={{ strong: <strong /> }} parent="p" />
          <ul>
            <li>{t('terms.s1.item1')}</li>
            <li><Trans i18nKey="terms.s1.item2" components={{ strong: <strong /> }} /></li>
            <li>{t('terms.s1.item3')}</li>
          </ul>
        </section>

        {/* Section II */}
        <section className="policy-section">
          <h2>{t('terms.s2.title')}</h2>
          <Trans i18nKey="terms.s2.intro" components={{ strong: <strong /> }} parent="p" />

          <div className="info-box">
            <h3>{t('terms.s2.privateTitle')}</h3>
            <Trans i18nKey="terms.s2.privateText" components={{ strong: <strong /> }} parent="p" />
          </div>

          <div className="info-box">
            <h3>{t('terms.s2.publicTitle')}</h3>
            <p>{t('terms.s2.publicIntro')}</p>
            <ul>
              <li>
                <strong>{t('terms.s2.organizedLabel')}</strong> — {t('terms.s2.organizedText')}
              </li>
              <li>
                <strong>{t('terms.s2.proposalLabel')}</strong> — {t('terms.s2.proposalText')}
              </li>
            </ul>
            <p>{t('terms.s2.approvalNote')}</p>
          </div>

          <Trans i18nKey="terms.s2.hashtagsText" components={{ strong: <strong /> }} parent="p" />

          <h3>{t('terms.s2.attendanceTitle')}</h3>
          <Trans i18nKey="terms.s2.attendanceText" components={{ strong: <strong /> }} parent="p" />
        </section>

        {/* Section III */}
        <section className="policy-section">
          <h2>{t('terms.s3.title')}</h2>
          <p>{t('terms.s3.intro')}</p>
          <ul>
            <li><Trans i18nKey="terms.s3.waiting" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s3.approved" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s3.discarded" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s3.inProgress" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s3.ended" components={{ strong: <strong /> }} /></li>
          </ul>
        </section>

        {/* Section IV */}
        <section className="policy-section">
          <h2>{t('terms.s4.title')}</h2>
          <Trans i18nKey="terms.s4.p1" components={{ strong: <strong /> }} parent="p" />
          <ul>
            <li><Trans i18nKey="terms.s4.item1" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s4.item2" components={{ strong: <strong /> }} /></li>
          </ul>
          <p>{t('terms.s4.p2')}</p>
          <Trans i18nKey="terms.s4.p3" components={{ strong: <strong /> }} parent="p" />
        </section>

        {/* Section V */}
        <section className="policy-section">
          <h2>{t('terms.s5.title')}</h2>
          <p>{t('terms.s5.intro')}</p>
          <ul>
            <li>
              <strong>{t('terms.s5.organizedLabel')}</strong> — {t('terms.s5.organizedText')}
            </li>
            <li>
              <strong>{t('terms.s5.proposalLabel')}</strong> — {t('terms.s5.proposalText')}
            </li>
          </ul>
          <p>{t('terms.s5.inviteText')}</p>

          <h3>{t('terms.s5.rightsTitle')}</h3>
          <ul>
            <li><Trans i18nKey="terms.s5.right1" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s5.right2" components={{ strong: <strong /> }} /></li>
          </ul>
        </section>

        {/* Section VI */}
        <section className="policy-section">
          <h2>{t('terms.s6.title')}</h2>
          <Trans i18nKey="terms.s6.intro" components={{ strong: <strong /> }} parent="p" />
          <ul>
            <li>{t('terms.s6.item1')}</li>
            <li>{t('terms.s6.item2')}</li>
            <li>{t('terms.s6.item3')}</li>
          </ul>
        </section>

        {/* Section VII */}
        <section className="policy-section">
          <h2>{t('terms.s7.title')}</h2>
          <Trans i18nKey="terms.s7.p1" components={{ strong: <strong /> }} parent="p" />
          <Trans i18nKey="terms.s7.p2" components={{ strong: <strong /> }} parent="p" />
          <p>{t('terms.s7.frontPageTitle')}</p>
          <ul>
            <li><Trans i18nKey="terms.s7.item1" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s7.item2" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s7.item3" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s7.item4" components={{ strong: <strong /> }} /></li>
          </ul>
        </section>

        {/* Section VIII */}
        <section className="policy-section">
          <h2>{t('terms.s8.title')}</h2>

          <h3>{t('terms.s8.photosTitle')}</h3>
          <Trans i18nKey="terms.s8.photosP1" components={{ strong: <strong />, em: <em /> }} parent="p" />
          <Trans i18nKey="terms.s8.photosP2" components={{ strong: <strong /> }} parent="p" />

          <h3>{t('terms.s8.proofTitle')}</h3>
          <p>{t('terms.s8.proofText')}</p>

          <h3>{t('terms.s8.visibilityTitle')}</h3>
          <Trans i18nKey="terms.s8.visibilityP1" components={{ strong: <strong /> }} parent="p" />
          <p>{t('terms.s8.visibilityP2')}</p>
          <p>{t('terms.s8.visibilityP3')}</p>

          <h3>{t('terms.s8.badgesTitle')}</h3>
          <Trans i18nKey="terms.s8.badgesP1" components={{ strong: <strong /> }} parent="p" />
          <ul>
            <li><Trans i18nKey="terms.s8.badgePrivate" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s8.badgeAnon" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s8.badgeBoth" components={{ strong: <strong /> }} /></li>
          </ul>
          <h3>{t('terms.s8.reactionsTitle')}</h3>
          <Trans i18nKey="terms.s8.reactionsP1" components={{ strong: <strong /> }} parent="p" />
          <Trans i18nKey="terms.s8.offendingText" components={{ strong: <strong /> }} parent="p" />
          <p>{t('terms.s8.avatarText')}</p>
        </section>

        {/* Section IX */}
        <section className="policy-section">
          <h2>{t('terms.s9.title')}</h2>
          <Trans i18nKey="terms.s9.p1" components={{ strong: <strong /> }} parent="p" />
          <p>{t('terms.s9.p2')}</p>
        </section>

        {/* Section X */}
        <section className="policy-section">
          <h2>{t('terms.s10.title')}</h2>
          <p>{t('terms.s10.intro')}</p>
          <ul>
            <li><Trans i18nKey="terms.s10.item1" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s10.item2" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s10.item3" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s10.item4" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s10.item5" components={{ strong: <strong /> }} /></li>
            <li><Trans i18nKey="terms.s10.item6" components={{ strong: <strong /> }} /></li>
          </ul>
          <p>{t('terms.s10.access')}</p>
        </section>

        {/* Section XI */}
        <section className="policy-section">
          <h2>{t('terms.s11.title')}</h2>
          <div className="warning-box">
            <p><strong>{t('terms.s11.warning')}</strong></p>
            <p>{t('terms.s11.p1')}</p>
            <p>{t('terms.s11.p2')}</p>
          </div>
        </section>

        {/* Section XII */}
        <section className="policy-section">
          <h2>{t('terms.s12.title')}</h2>
          <p>{t('terms.s12.p1')}</p>
          <p>{t('terms.s12.p2')}</p>
          <ul>
            <li>{t('terms.s12.item1')}</li>
            <li>{t('terms.s12.item2')}</li>
            <li>{t('terms.s12.item3')}</li>
            <li>{t('terms.s12.item4')}</li>
            <li>{t('terms.s12.item5')}</li>
          </ul>
          <p>{t('terms.s12.p3')}</p>
        </section>

        {/* Section XIII */}
        <section className="policy-section">
          <h2>{t('terms.s13.title')}</h2>
          <p>{t('terms.s13.intro')}</p>
          <ul>
            <li>{t('terms.s13.item1')}</li>
            <li>{t('terms.s13.item2')}</li>
            <li>{t('terms.s13.item3')}</li>
            <li>{t('terms.s13.item4')}</li>
          </ul>
          <p>{t('terms.s13.outro')}</p>
        </section>

        {/* Section XIV */}
        <section className="policy-section">
          <h2>{t('terms.s14.title')}</h2>
          <p>{t('terms.s14.text')}</p>
        </section>

        <footer className="policy-footer">
          <p>
            <a href="/privacy">{t('common.privacyPolicy')}</a>
          </p>
        </footer>
      </div>
    </div>
  );
}

export default TermsOfUse;
